import React, {useState} from 'react';
import {
    Box,
    Container,
    IconButton,
    Tab,
    Tabs,
    Tooltip,
    Typography,
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import {Link} from 'react-router-dom';
import RapporteTab from './RapporteTab';
import RechnungenTab from './RechnungenTab';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`rapporte-rechnung-tabpanel-${index}`}
            aria-labelledby={`rapporte-rechnung-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{py: 3}}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `rapporte-rechnung-tab-${index}`,
        'aria-controls': `rapporte-rechnung-tabpanel-${index}`,
    };
}

const RapporteRechnung: React.FC = () => {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    return (
        <Container maxWidth="xl" sx={{py: 4}}>
            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2}}>
                <Typography variant="h4" component="h1">
                    Rapporte & Rechnung
                </Typography>
                <Tooltip title="Einstellungen">
                    <IconButton
                        component={Link}
                        to="/rapporte-rechnung/settings"
                        color="primary"
                    >
                        <SettingsIcon />
                    </IconButton>
                </Tooltip>
            </Box>

            <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                <Tabs value={tabValue} onChange={handleTabChange} aria-label="Rapporte und Rechnungen Tabs">
                    <Tab label="Rapporte" {...a11yProps(0)} />
                    <Tab label="Rechnungen" {...a11yProps(1)} />
                </Tabs>
            </Box>

            <TabPanel value={tabValue} index={0}>
                <RapporteTab />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
                <RechnungenTab />
            </TabPanel>
        </Container>
    );
};

export default RapporteRechnung;
